import { EmailTabs } from '@/constants';
import EmailHistory from './components/EmailHistory';
import EmailTemplates from './components/EmailTemplates';

export const emailTabsConfig = [
  {
    id: EmailTabs.ToCustomer,
    content: 'To customers',
    component: <EmailTemplates />,
  },
  {
    id: EmailTabs.ToYourself,
    content: 'To yourself',
    component: <EmailTemplates />,
  },
  {
    id: EmailTabs.SendingHistory,
    content: 'Sending history',
    component: <EmailHistory />,
  },
];
